import { useQuery } from "@tanstack/react-query";
import { OmsProduct, Stage } from "../lusca-search-api/generated-src";
import { OmsReportsApiFactory } from "../lusca-search-api/LuscaSearchApiFactory";

export function useOmsContexts() {
  return useQuery({
    queryKey: ["oms-contexts"],
    retry: false,
    staleTime: 60_000,
    queryFn: async () =>
      (await OmsReportsApiFactory().getOmsReportContexts(Stage.Prod)).data,
  });
}

export function useOmsContext(product?: OmsProduct, account = "13051") {
  return useQuery({
    queryKey: ["oms-context", product, account],
    enabled: Boolean(product),
    retry: false,
    staleTime: 60_000,
    queryFn: async () =>
      (
        await OmsReportsApiFactory().getOmsReportContext(
          product as OmsProduct,
          account,
          Stage.Prod
        )
      ).data,
  });
}
